











































import { Component, Watch, Mixins } from "vue-property-decorator";
import NotificationItem from "./NotificationItem.vue";
import Notification from "@/models/Notifications";
import store from "../store";
import QueryableInterface from "@/interfaces/QueryableInterface";
import NotificationsMixin, {
  SetAsReadParams,
} from "@/mixins/http/Notifications";
import { AUTH_ENDPOINT } from "@/constants";
import { Getter } from "vuex-class";

const requestTag = "reportJobs";

@Component({
  components: {
    NotificationItem,
  },
})
export default class Notifications extends Mixins(NotificationsMixin) {
  notifications: Notification[] = [];
  show = false;
  connectedToWs = false;

  @Getter("auth/accessToken") accessToken!: string;

  get slicedNotifications(): Notification[] {
    return this.notifications.slice(0, 5);
  }

  get notificationsToRead(): boolean {
    const toRead = (notification: Notification) =>
      notification.status === "ready";
    return this.slicedNotifications.some(toRead);
  }

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      this.load();
      setTimeout(this.setAllAsRead, 3000);
    }
  }

  async load() {
    const params: QueryableInterface = {
      filter: { status: ["ready", "read"] },
    };

    const notifications = await this.getNotifications(params, requestTag);
    this.notifications = notifications;
  }

  get channels() {
    return {
      NotificationsChannel: {
        connected: () => {
          this.connectedToWs = true;
        },
        rejected: () => {
          this.connectedToWs = false;
        },
        received: (data: any) => {
          this.load();
        },
        disconnected: () => {
          this.connectedToWs = false;
        },
      },
    };
  }

  setAllAsRead() {
    if (!this.slicedNotifications) return;

    const notificationsIds = this.slicedNotifications.map((notification) => {
      return notification.id;
    });

    const params: SetAsReadParams = { notification_ids: notificationsIds };

    if (notificationsIds.length !== 0) {
      this.setNotificationRead(params, requestTag).then(() => {
        this.load();
      });
    }
  }

  toggleNotifications() {
    this.show = !this.show;
  }

  hideComponent() {
    this.show = false;
  }

  created() {
    this.load();
  }

  mounted() {
    this.$cable.connection?.connect(
      AUTH_ENDPOINT + "/cable?token=" + this.accessToken
    );

    this.$cable.subscribe({
      channel: `NotificationsChannel`,
    });
  }
}
